
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import PhoneNumberInput from '@/components/shared/PhoneNumberInput.vue';
import '@/validation-rules';

@Component({
	components: {
		PhoneNumberInput,
		ValidationProvider
	}
})
export default class ContactDetailsSection extends Vue {
	@Prop({ type: Object, required: true }) private formData!: { firstName: string; lastName: string; email: string; phone_number: string };
}
